import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col
} from 'reactstrap';
import classnames from 'classnames';
import TableContainerReactTable from '../../../../Components/Common/TableContainerReactTable';

interface BarcodeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const BarcodeModal: React.FC<BarcodeModalProps> = ({ isOpen, onClose }) => {
  const [activeTab] = useState('1');
  const [barcodeInput, setBarcodeInput] = useState('');
  const [barcodes, setBarcodes] = useState<any[]>([
    { barcode: '123456789012', type: 'EAN-13', value: 'Product A', picked: false },
    { barcode: '987654321098', type: 'UPC', value: 'Product B', picked: false },
    { barcode: '111111111111', type: 'EAN-8', value: 'Product C', picked: false },
    { barcode: '222222222222', type: 'Code 128', value: 'Product D', picked: false },
    { barcode: '333333333333', type: 'QR', value: 'Product E', picked: false },
   
  ]);

  const hasRecords = barcodes.length > 0;
  const hasPicked = barcodes.some(b => b.picked);

  // Placeholder handlers
  const handleAddBarcode = () => {
    if (!barcodeInput.trim()) return;
    setBarcodes(prev => [
      ...prev,
      { barcode: barcodeInput, type: '', value: '', picked: false }
    ]);
    setBarcodeInput('');
  };

  const handleDelete = () => {
    setBarcodes(prev => prev.filter(b => !b.picked));
  };

  const columns = [
    {
      header: 'Pick',
      accessorKey: 'pick',
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={row.original.picked}
          onChange={() => {
            setBarcodes((prev: any[]) =>
              prev.map((b, idx) =>
                idx === row.index ? { ...b, picked: !b.picked } : b
              )
            );
          }}
        />
      ),
      enableColumnFilter: false,
    },
    {
      header: 'Barcode',
      accessorKey: 'barcode',
      enableColumnFilter: false,
    },
    {
      header: 'Type',
      accessorKey: 'type',
      enableColumnFilter: false, 
      required: false
    },
    {
      header: 'Value',
      accessorKey: 'value',
      enableColumnFilter: false,
      required: false
    },
  ];

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="lg">
      <ModalHeader toggle={onClose}>Barcodes</ModalHeader>
      <ModalBody>
        <Nav pills className="nav nav-tabs-custom arrow-navtabs nav-success mb-3">
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === '1' })}
              tabIndex={0}
              aria-label="Barcodes Tab"
            >
              Barcodes
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <div className="mb-3">
              <Row className="g-2 align-items-center">
                <Col sm={9}>
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={barcodeInput}
                    onChange={e => {
                      const digitsOnly = e.target.value.replace(/\D/g, '');
                      setBarcodeInput(digitsOnly);
                    }}
                    className="form-control form-control-sm"
                    placeholder="Barcode"
                  />
                </Col>
                <Col sm={3}>
                  <button
                    className="btn btn-soft-primary btn-sm w-100"
                    onClick={handleAddBarcode}
                  >
                    Add & Continue
                  </button>
                </Col>
              </Row>
            </div>
            <TableContainerReactTable
              columns={columns}
              data={barcodes}
              isGlobalFilter={false}
              customPageSize={10}
              tableClass="table-centered align-middle table-nowrap mb-0"
              theadClass="table-light"
              thClass="px-3 py-2"
              verticalLines={true}
            />
          </TabPane>
        </TabContent>
      </ModalBody>
      <ModalFooter className="flex justify-between w-full">
        <div>
          <button className="btn btn-soft-primary btn-sm me-2" style={{minWidth: 80}}>Update Primary</button>
          <button className="btn btn-soft-dark btn-sm me-2" style={{minWidth: 80}} disabled>Save</button>
          <button
            className="btn btn-soft-danger btn-sm"
            style={{minWidth: 80}}
            disabled={!hasRecords || !hasPicked}
            onClick={handleDelete}
          >
            Delete
          </button>
        </div>
        <button className="btn btn-soft-dark btn-sm" style={{minWidth: 80}} onClick={onClose}>Close</button>
      </ModalFooter>
    </Modal>
  );
};

export default BarcodeModal; 